// **فهرس البحث** (قرار المالك: «اعمل حاجة تخلّيني أدوّر على أي حاجة نسيت مكانها فين —
// أبحث عن كشف المرتبات أو كلمة خصم إداري، يدخلني عليها على طول»).
//
// كل وجهةٍ في البرنامج سطرٌ هنا: التبويب الرئيسي، والقسم الفرعي إن كان، واسمها كما
// تُقرأ، و**كلماتٌ يبحث بها الناس** لا أسماء الشاشات وحدها — فمن كتب «خصم إداري» وجد
// «مستحقات الموظفين» لأن الزرّ هناك، وإن لم يكن «خصم إداري» تبويبًا.
//
// **والفهرس لا يعرف الصلاحيات**: يُصفّى عند العرض بالتبويبات الظاهرة للمستخدم نفسه،
// فلا يجد بياعٌ «الخزنة» ولا يجد أدمن «مرتبي». والأسماء هنا تتبع أسماء الشاشات؛ ومن
// غيّر اسم تبويبٍ فليغيّره هنا (اختبار الواجهة يحرس التطابق للتبويبات الرئيسية).
export interface SearchEntry {
  /** معرّف التبويب الرئيسي كما في `App.tsx` (`#tab`) */
  tab: string;
  /** مفتاح `useStickySection` للصفحة وقسمُها — حين تكون الوجهة قسمًا داخل التبويب */
  page?: string;
  section?: string;
  title: string;
  /** أين تقع — يُقرأ تحت العنوان: «الإدارة المالية ← مستحقات الموظفين» */
  where: string;
  keywords: string[];
  /** اعتماد التقييمات لصاحب الصلاحية وحده */
  requires?: 'approver';
  /** **بطاقةٌ بعينها في الصفحة** (01/10/2026): معرّف عنصرٍ يُنزل إليه بعد فتح التبويب — «تارجت المتابعات» مثلًا */
  anchor?: string;
}

const E = (tab: string, title: string, where: string, keywords: string[], sub?: { page?: string; section?: string; anchor?: string }, requires?: 'approver'): SearchEntry =>
  ({ tab, title, where, keywords, ...(sub ?? {}), ...(requires ? { requires } : {}) });

export const SEARCH_INDEX: SearchEntry[] = [
  // ---------------------------------------------------------------- الجميع
  E('home', 'الصفحة الرئيسية', 'تبويب', ['الرئيسية', 'البداية', 'هوم', 'home']),
  E('crm', 'تسجيل متابعة جديدة', 'المتابعات اليومية ← تسجيل متابعة', ['متابعة جديدة', 'سجل متابعة', 'عميل جديد', 'كلمت عميل', 'مكالمة جديدة'], { anchor: 'quick-add-form' }),
  E('crm', 'المتابعات المستحقة — تحديث موقف المتابعة', 'المتابعات اليومية ← قوائم المتابعات',
    ['المستحقة', 'المتأخرة', 'القادمة', 'تحديث موقف المتابعة', 'تم المتابعة', 'سجل العميل', 'كل المتابعات', 'شيت المتابعات', 'تصدير المتابعات', 'متابعات النهاردة'],
    { anchor: 'follow-up-lists' }),
  E('crm', 'بنك الأرقام — اسحب أرقامك', 'المتابعات اليومية ← بنك الأرقام', ['بنك الأرقام', 'اسحب أرقام', 'سحب أرقام', 'أرقام قديمة', 'خلص الأرقام'], { anchor: 'lead-bank' }),
  E('crm', 'طلبات من موقع الشركة', 'المتابعات اليومية ← طلبات الموقع', ['طلبات الموقع', 'طلب من الموقع', 'فورم الموقع', 'عميل من الموقع'], { anchor: 'web-leads' }),
  E('chat', 'شات الموقع', 'تبويب', ['شات العملاء', 'شات الموقع', 'دردشة العملاء', 'لايف شات', 'رسايل العملاء', 'عميل بيكلمنا']),
  E('crm', 'المتابعات اليومية', 'تبويب', ['متابعة', 'تسجيل متابعة', 'عميل', 'مكالمة', 'واتساب', 'لم يرد', 'بنك الأرقام', 'سحب أرقام', 'سيناريوهات', 'إنشاء حجز من متابعة', 'CRM']),
  E('declarations', 'إقرار مراجعة الطيران', 'تبويب', ['إقرار', 'إقرار مراجعة', 'مراجعة الطيران', 'بدون حجز', 'حوّله لحجز']),
  E('bookings', 'الحجوزات', 'تبويب', ['حجز', 'إنشاء حجز', 'حجز جديد', 'دفعة', 'إثبات دفع', 'مرفقات', 'تذكرة', 'فندق', 'تأشيرة', 'أرشفة حجز', 'رقم الحجز', 'تصفية الحساب', 'تصفية حساب الحجز', 'حجز مبدئي', 'تعديل حجز']),
  E('upcoming', 'هيسافروا قريب', 'تبويب', ['سفر', 'مسافرين', 'تاريخ السفر', 'رحلات قادمة', 'تذكير سفر']),
  E('my-notes', 'ملاحظاتي', 'تبويب', ['ملاحظة', 'ملاحظات خاصة', 'مذكرة', 'تدوين']),
  E('guide', 'دليلك في السياحة', 'تبويب', ['دليل', 'مطارات', 'تأشيرات', 'دول', 'معلومات سياحية', 'شركات طيران']),
  E('team-chat', 'شات الفريق', 'تبويب', ['شات', 'جروب', 'رسالة', 'رسايل', 'زملاء', 'أونلاين', 'مين فاتح', 'واتساب', 'رد على رسالة', 'شات الموظفين']),
  E('team-chat', 'شات الفريق — 💡 تطوير', 'شات الفريق ← تطوير', ['تطوير', 'أفكار', 'فكرة', 'اقتراح', 'تحسين البرنامج']),
  // ---------------------------------------------------------------- البياع والشريك
  E('commission', 'خطة العمولات', 'تبويب — «عمولتي»', ['عمولتي', 'عمولة', 'نسبة العمولة', 'تسوية', 'تارجت المبيعات', 'مكافأة التقييمات', 'مكافأة بنك الأرقام', 'الحافز']),
  E('google-rating', 'تقييم Google Map', 'تبويب', ['تقييم', 'جوجل', 'Google', 'صورة التقييم', 'رفع تقييم', 'مكافأة تقييم']),
  E('my-payslip', 'مرتبي', 'تبويب', ['مرتب', 'مرتبي', 'كشف مرتبي', 'كشف الراتب', 'راتب', 'خصوماتي', 'خصم', 'الصافي', 'سلفة', 'طلب سلفة', 'مكافأة إدارية', 'خصم إداري', 'اللي ليك واللي عليك', 'قوانين', 'طباعة الكشف']),
  E('attendance', 'الحضور والانصراف', 'تبويب', ['حضور', 'انصراف', 'بصمة', 'تسجيل حضور', 'إجازة', 'طلب إجازة', 'تأخير', 'غياب', 'رصيد إجازات']),
  E('my-rank', 'ترتيبي', 'تبويب', ['ترتيب', 'ترتيبي', 'الأول', 'لوحة الشرف', 'موظف الشهر']),
  E('evaluate-me', 'قيّمني', 'تبويب', ['قيّمني', 'تقييم أدائي', 'تقييمي', 'نقاط']),
  E('my-partner-account', 'حساباتي', 'تبويب (الشريك)', ['حساباتي', 'حساب الشريك', 'طلب مصروف', 'أرباحي', 'كشف الشريك', 'سحوبات']),
  // ---------------------------------------------------------------- المالك: الخزنة
  E('treasury', 'الخزنة — الأرصدة', 'الخزنة ← الأرصدة', ['الخزنة', 'خزنة', 'أرصدة', 'كاش', 'بنك', 'محفظة', 'رصيد', 'مطابقة', 'عملية جديدة', 'أصول الشركة', 'غير سائل', 'أرصدة سيستم', 'NDC', 'GBEDS', 'صافي مركزي', 'نسخة PDF'], { page: 'treasury', section: 'balances' }),
  E('treasury', 'الخزنة — السجل', 'الخزنة ← السجل', ['سجل الخزنة', 'حركات', 'تحويل', 'مسح عملية', 'حركة'], { page: 'treasury', section: 'movements' }),
  E('treasury', 'الخزنة — الذهب', 'الخزنة ← خاص ← الذهب', ['ذهب', 'جرام', 'سعر الجرام', 'عيار'], { page: 'treasury', section: 'gold' }),
  E('treasury', 'الخزنة — الأصول', 'الخزنة ← خاص ← الأصول', ['أصول', 'ودائع', 'وديعة', 'عقار'], { page: 'treasury', section: 'assets' }),
  E('treasury', 'الخزنة — مصاريفي الشخصية', 'الخزنة ← خاص ← مصاريفي الشخصية', ['مصاريفي', 'مصروف شخصي', 'مصاريف شخصية', 'سحبته منين'], { page: 'treasury', section: 'personal' }),
  // ---------------------------------------------------------------- الأدمن
  E('admin-dashboard', 'لوحة الأدمن', 'تقارير ← لوحة الأدمن', ['لوحة', 'اللوحة', 'إحصائيات', 'تقارير', 'أرقام الشهر', 'إجمالي المبيعات'], { page: 'dashboard', section: 'dashboard' }),
  E('admin-dashboard', 'لوحة الترتيب', 'تقارير ← لوحة الترتيب', ['ترتيب البياعين', 'الأول', 'الأعلى مبيعًا', 'لوحة الشرف'], { page: 'dashboard', section: 'leaderboard' }),
  E('admin-dashboard', 'تقرير المدفوعات', 'تقارير ← تقرير المدفوعات', ['مدفوعات', 'تقرير الدفعات', 'طرق الدفع'], { page: 'dashboard', section: 'payments' }),
  E('admin-analytics', 'KPI · Data Analysis', 'تبويب', ['تحليل', 'أداء', 'تحليل الأداء', 'kpi', 'data', 'analysis', 'مقارنة', 'اتجاه', 'تقرير PDF', 'تصدير Excel', 'صافي الربح', 'هامش']),
  E('admin-crm', 'تارجت المتابعات اليومي ومكافأته', 'نشاط الشركة ← تارجت المتابعات',
    ['تارجت المتابعات', 'تارجت اليوم', 'حد المكافأة', 'مكافأة المتابعات', 'خصم المتابعات', 'عدد المتابعات المطلوبة', 'مكافأة عند الحد', 'خصم لو أقل'],
    { anchor: 'crm-target' }),
  E('admin-crm', 'بنك الأرقام — حدّ السحب ومين سحب كام', 'نشاط الشركة ← بنك الأرقام', ['حد السحب', 'حد سحب الأرقام', 'كام رقم في اليوم', 'مين سحب', 'إرجاع أرقام', 'بنك الأرقام'], { anchor: 'lead-bank-summary' }),
  E('admin-crm', 'مكافأة بنك الأرقام', 'نشاط الشركة ← مكافأة بنك الأرقام', ['مكافأة بنك الأرقام', 'مكافأة الحجز من البنك'], { anchor: 'lead-bank-bonus' }),
  E('admin-crm', 'رفع شيت أرقام لبياع', 'نشاط الشركة ← رفع شيت', ['رفع شيت', 'استيراد أرقام', 'شيت أرقام', 'شيت عملاء', 'إضافة أرقام للبنك'], { anchor: 'lead-bank-import' }),
  E('admin-crm', 'طلبات الموقع — راحت لمين', 'نشاط الشركة ← طلبات الموقع', ['طلبات الموقع', 'فورم الموقع', 'طلبات العملاء من الموقع'], { anchor: 'web-leads-admin' }),
  E('admin-crm', 'التفصيل لكل بياع — شغل المتابعات', 'نشاط الشركة ← التفصيل لكل بياع', ['متابعات كل بياع', 'شغل البياعين', 'أداء المتابعات'], { anchor: 'crm-by-seller' }),
  E('admin-crm', 'نشاط الشركة', 'تبويب', ['نشاط', 'متابعات البياعين', 'بنك الأرقام', 'حد السحب', 'سجل السحب', 'مكافأة بنك الأرقام', 'الحد والمبلغ', 'التفصيل لكل بياع']),
  E('admin-payments', 'حسابات الاستلام', 'التحصيلات ← حسابات الاستلام', ['حسابات الاستلام', 'راحت لحساب مين', 'انستا', 'فودافون كاش', 'محافظ', 'حساب استلام'], { page: 'payments', section: 'destinations' }),
  E('admin-payments', 'التحصيلات', 'تبويب', ['تقرير التحصيلات', 'تحصيل', 'تحصيلات', 'اعتماد دفعة', 'مراجعة دفعات', 'إثبات', 'إلغاء دفعة']),
  E('admin-settlements', 'التسويات', 'الإدارة المالية ← التسويات', ['تسوية', 'تسويات', 'حساب العمولات', 'اعتماد التسوية', 'عمولات الشهر'], { page: 'settlements', section: 'settlements' }),
  E('admin-settlements', 'بيان المرتبات', 'الإدارة المالية ← بيان المرتبات',['مرتبات', 'تسجيل مرتب', 'مرتب الشهر', 'مرتبات الشهر'], { page: 'settlements', section: 'salaries' }),
  E('admin-settlements', 'مستحقات الموظفين — كشف المرتبات', 'الإدارة المالية ← مستحقات الموظفين', ['كشف المرتبات', 'كشف مرتبات', 'كشوف', 'مستحقات', 'خصم إداري', 'مكافأة إدارية', 'طباعة كشف', 'كشف السنة', 'الصافي', 'CSV'], { page: 'settlements', section: 'payroll' }),
  // بابٌ خاصّ بعد «مستحقات الموظفين» (قرار المالك 24/09/2026) — والقرار فيه: موافقة أو رفض
  E('admin-settlements', 'السلف — طلبات السلف وقرارها', 'الإدارة المالية ← السلف', ['سلف', 'سلفة', 'طلب سلفة', 'موافقة سلفة', 'رفض سلفة', 'السلف'], { page: 'settlements', section: 'advances' }),
  E('admin-settlements', 'حالات المراجعة', 'الإدارة المالية ← حالات المراجعة', ['مراجعة', 'حالات', 'حالة مراجعة'], { page: 'settlements', section: 'cases' }),
  E('admin-settlements', 'مصروفات ثابتة', 'الإدارة المالية ← مصروفات ثابته', ['مصروفات', 'مصاريف', 'إيجار', 'إعلانات', 'صافي الربح', 'مصاريف الشهر'], { page: 'settlements', section: 'expenses' }),
  E('admin-settlements', 'التارجت الشهري / السنوي', 'الإدارة المالية ← التارجت', ['تارجت المبيعات', 'تارجت الشهر', 'مكافأة التارجت', 'مكافأة سنوية', 'هدف'], { page: 'settlements', section: 'policy' }),
  E('admin-settlements', 'خطط العمولات', 'الإدارة المالية ← خطط العمولات', ['خطة عمولة', 'خطط', 'نسب العمولة', 'نسبة', 'إسناد خطة'], { page: 'settlements', section: 'plans' }),
  E('admin-settlements', 'فترات الحافز', 'الإدارة المالية ← فترات الحافز', ['حافز', 'فترة حافز', 'نسبة الحافز'], { page: 'settlements', section: 'incentives' }),
  E('admin-settlements', 'اعتماد تقييمات Google Maps', 'الإدارة المالية ← تقييمات Google Maps', ['اعتماد تقييم', 'تقييمات', 'جوجل', 'Google', 'طابور التقييمات'], { page: 'settlements', section: 'ratings' }, 'approver'),
  E('admin-attendance', 'لوحة الحضور والانصراف', 'الحضور والإجازات ← لوحة الحضور والانصراف', ['لوحة اليوم', 'حضور يوم', 'حضور اليوم', 'مين حضر', 'الحضور والإجازات', 'بصمات اليوم'], { page: 'attendance', section: 'today' }),
  E('admin-attendance', 'أيام موظف', 'الحضور والإجازات ← أيام موظف', ['أيام موظف', 'حضور موظف', 'تعديل حضور', 'تصحيح بصمة'], { page: 'attendance', section: 'days' }),
  E('admin-attendance', 'الإجازات', 'الحضور والإجازات ← الإجازات', ['إجازات', 'طلبات الإجازة', 'اعتماد إجازة', 'رفض إجازة'], { page: 'attendance', section: 'leave' }),
  E('admin-attendance', 'الجداول', 'الحضور والإجازات ← الجداول', ['جدول', 'جداول العمل', 'ميعاد الدوام', 'ورديات'], { page: 'attendance', section: 'schedules' }),
  E('admin-attendance', 'تقرير الحضور', 'الحضور والإجازات ← التقرير', ['تقرير الحضور', 'تقرير الشهر', 'تأخيرات', 'غيابات'], { page: 'attendance', section: 'report' }),
  E('admin-attendance', 'المكاتب', 'الحضور والإجازات ← المكاتب', ['مكاتب', 'مكتب', 'موقع المكتب', 'نطاق البصمة'], { page: 'attendance', section: 'offices' }),
  E('admin-employees', 'ملفات الموظفين', 'الموظفين ← ملفات الموظفين', ['موظف', 'موظفين', 'بيانات موظف', 'رقم وظيفي', 'تعطيل حساب', 'صلاحيات', 'إضافة موظف', 'مستخدم'], { page: 'employees', section: 'profiles' }),
  E('admin-employees', 'موظف الشهر', 'الموظفين ← موظف الشهر', ['موظف الشهر', 'تكريم', 'الأفضل'], { page: 'employees', section: 'employee-of-month' }),
  // ---------------------------------------------------------------- أدوات هامة
  E('quote', 'عرض سعر', 'أدوات هامة', ['عرض سعر', 'عرض', 'كوتيشن', 'quotation']),
  E('pricing', 'حاسبة سعر البيع', 'أدوات هامة', ['حاسبة', 'سعر البيع', 'هامش', 'تكلفة المورد']),
  E('installment', 'رسوم التقسيط', 'أدوات هامة', ['تقسيط', 'فاليو', 'كونتاكت', 'سهولة', 'رسوم']),
  E('tafqeet', 'تفقيط المبالغ', 'أدوات هامة', ['تفقيط', 'بالحروف', 'مبلغ بالحروف', 'فقط لا غير', 'شيك', 'إيصال', 'كتابة المبلغ']),
  E('hijri', 'ميلادي ↔ هجري', 'أدوات هامة', ['هجري', 'ميلادي', 'تحويل تاريخ', 'أم القرى', 'رمضان', 'ذو الحجة', 'تقويم', 'محرم']),
  E('clock', 'توقيت المدن', 'أدوات هامة', ['توقيت', 'ساعة', 'فرق التوقيت', 'عواصم']),
  E('airports', 'أكواد المطارات', 'تبويب', ['مطار', 'مطارات', 'كود المطار', 'IATA', 'اياتا', 'طيران', 'رحلة', 'دولي']),
  E('fx', 'محوّل العملات', 'أدوات هامة', ['عملات', 'دولار', 'ريال', 'سعر الصرف', 'تحويل عملة', 'البنك المركزي']),
  E('hotel-voucher', 'حجز فندق مبدئي', 'أدوات هامة', ['فاوتشر', 'فندق مبدئي', 'حجز فندق', 'voucher']),
  // ---------------------------------------------------------------- الإعدادات
  E('account', 'بيانات الحساب', 'إعدادات الحساب', ['حسابي', 'بياناتي', 'اسمي', 'رقم تليفوني', 'إعدادات']),
  E('account-password', 'كلمة مرور الحساب', 'إعدادات الحساب', ['كلمة المرور', 'كلمة السر', 'باسورد', 'تغيير كلمة المرور']),
  E('account-lock', 'كلمة مرور الخزنة', 'إعدادات الحساب', ['قفل الشاشة', 'كلمة مرور الخزنة', 'قفل الإدارة المالية']),
  E('admin-audit', 'سجل التدقيق', 'إعدادات الحساب', ['تدقيق', 'سجل', 'مين عمل إيه', 'تغييرات']),
  E('admin-backups', 'النسخ الاحتياطي', 'إعدادات الحساب', ['نسخة احتياطية', 'باك أب', 'backup', 'استعادة', 'تنزيل النسخة']),
];

/** توحيد الحروف العربية للمطابقة: لا فرق بين أ/إ/آ وا، ولا ة/ه، ولا ى/ي، وتُحذف التشكيل والكشيدة. */
export function normalizeAr(s: string): string {
  return s.toLowerCase()
    .replace(/[ً-ْـ]/g, '')
    .replace(/[أإآ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي').replace(/ؤ/g, 'و').replace(/ئ/g, 'ي')
    .replace(/[«»"'،,.:؛;()\-_/←↔—?؟!]/g, ' ')
    .replace(/\s+/g, ' ').trim();
}

/**
 * **البحث بالمعنى لا بالاسم حرفيًّا** (قرار المالك 01/10/2026: «عاوز لما أبحث عن أي حاجة بدلالة معيّنة ومش لازم تبقى
 * اسمها بالظبط تظهر ليا — لو كتبت تارجت المتابعات يظهر ليا أدخل فين على طول، لما أبحث عن مرتبات الموظفين تفتحلي…
 * يظهر ليا الأقرب داخل البرنامج»). كان البحث يشترط ظهور كل كلمةٍ بنصّها، فـ«تارجت المتابعات» لا يجد شيئًا لأن
 * «المتابعات» بأداة التعريف ليست في الفهرس. الآن:
 *   • **جذرٌ خفيف** لكل كلمة: تُنزع «ال/وال/بال/لل…» من أوّلها و«ات/ين/ون/ه/ي…» من آخرها — فالمتابعات = متابعة،
 *     ومرتبات = مرتبي = المرتب، والموظفين = موظف.
 *   • **مرادفات** بلسان الناس: راتب = مرتب = قبض، هدف = تارجت، بونص = مكافأة = حافز، جزاء = خصم…
 *   • **تسامحٌ مع الخطأ الإملائي**: حرفٌ زائد أو ناقص أو مبدَّل في الكلمة الطويلة.
 *   • **الأقرب أوّلًا** بالنقاط: كلمة في العنوان أثقل من كلمة في الكلمات المفتاحية، والعبارة كاملةً تُرجّح — ولا
 *     يشترط أن تطابق كل كلمة؛ نصفُها يكفي، فـ«ادخل فين أعدّل تارجت المتابعات» تجد «تارجت المتابعات».
 */
const PREFIXES = ['وال', 'بال', 'فال', 'كال', 'لل', 'ال'];
const SUFFIXES = ['يات', 'ات', 'ين', 'ون', 'يه', 'ها', 'هم', 'كم', 'نا', 'ه', 'ي'];

export function stemAr(word: string): string {
  let s = word;
  for (const p of PREFIXES) if (s.startsWith(p) && s.length - p.length >= 3) { s = s.slice(p.length); break; }
  for (const x of SUFFIXES) if (s.endsWith(x) && s.length - x.length >= 3) { s = s.slice(0, -x.length); break; }
  return s;
}

/** كلماتٌ لا تدلّ على وجهة — «ادخل فين أعدّل…» — تُتجاهل في المطابقة */
const STOP = new Set(['في', 'فى', 'على', 'علي', 'من', 'عن', 'الي', 'لي', 'ليا', 'انا', 'عاوز', 'عايز', 'محتاج', 'ازاي', 'فين', 'اين',
  'كيف', 'ادخل', 'اعدل', 'اغير', 'اعمل', 'اشوف', 'افتح', 'اروح', 'صفحه', 'شاشه', 'مكان', 'بتاع', 'بتاعه', 'بتاعت', 'دي', 'ده', 'و', 'او',
  'ال', 'هو', 'هي', 'كل', 'بس'].map(normalizeAr));

/** مجموعات المرادفات — كلُّ مجموعةٍ معنًى واحد بألفاظ الناس */
const SYNONYMS: string[][] = [
  ['مرتب', 'راتب', 'رواتب', 'قبض', 'مرتبات', 'معاش', 'salary', 'payroll', 'كشف'],
  ['تارجت', 'تارجيت', 'هدف', 'اهداف', 'target', 'مستهدف'],
  ['متابعه', 'متابعات', 'فولو', 'follow', 'crm', 'كول', 'مكالمه', 'مكالمات'],
  ['موظف', 'موظفين', 'عمال', 'فريق', 'بياع', 'بياعين', 'سيلز', 'sales', 'staff', 'زملاء'],
  ['مكافاه', 'مكافات', 'بونص', 'bonus', 'حافز', 'حوافز', 'جايزه'],
  ['خصم', 'خصومات', 'جزاء', 'جزاءات', 'غرامه'],
  ['حجز', 'حجوزات', 'booking', 'بوكنج'],
  ['عميل', 'عملاء', 'زبون', 'زباين', 'customer', 'كلاينت'],
  ['سلفه', 'سلف', 'قرض', 'سلفيات'],
  ['اجازه', 'اجازات', 'اذن', 'عطله', 'leave', 'غياب'],
  ['حضور', 'بصمه', 'دوام', 'انصراف', 'تاخير'],
  ['شات', 'دردشه', 'رسايل', 'رساله', 'محادثه', 'chat'],
  ['عموله', 'عمولات', 'كوميشن', 'commission'],
  ['خزنه', 'خزينه', 'فلوس', 'كاش', 'نقديه', 'رصيد', 'ارصده'],
  ['تقرير', 'تقارير', 'report', 'احصائيات', 'احصائيه'],
  ['دفعه', 'دفعات', 'دفع', 'تحصيل', 'تحصيلات', 'payment', 'فلوس العميل'],
  ['مصاريف', 'مصروفات', 'مصروف', 'نفقات'],
  ['باسورد', 'password', 'مرور', 'سر'],
  ['تذكره', 'تذاكر', 'طيران', 'رحله', 'رحلات', 'ticket'],
  ['فندق', 'فنادق', 'hotel'],
  ['تاشيره', 'تاشيرات', 'فيزا', 'visa'],
  ['ترتيب', 'مركز', 'rank', 'شرف'],
  ['تقييم', 'تقييمات', 'ريفيو', 'review', 'جوجل', 'google'],
  ['ارقام', 'داتا', 'ليدز', 'leads', 'نمر', 'بنك'],
  ['حد', 'حدود', 'limit', 'سقف'],
  ['تطوير', 'افكار', 'فكره', 'اقتراح', 'اقتراحات', 'تحسين'],
  ['موقع', 'ويب', 'website', 'اونلاين'],
  ['نسخه', 'باك', 'backup', 'احتياطي'],
];
const SYN_OF = (() => {
  const m = new Map<string, Set<string>>();
  for (const group of SYNONYMS) {
    const stems = group.flatMap(w => normalizeAr(w).split(' ')).map(stemAr);
    for (const s of stems) m.set(s, new Set([...(m.get(s) ?? []), ...stems]));
  }
  return m;
})();

/** مسافة التحرير (Levenshtein) — بحدٍّ أقصى يوقف الحساب مبكّرًا */
function editDistance(a: string, b: string, max: number): number {
  if (Math.abs(a.length - b.length) > max) return max + 1;
  let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const cur = [i];
    let best = i;
    for (let j = 1; j <= b.length; j++) {
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      best = Math.min(best, cur[j]);
    }
    if (best > max) return max + 1;
    prev = cur;
  }
  return prev[b.length];
}

/** قرب كلمةٍ من كلمة (بعد الجذر): 1 تطابق، ثم البادئة، ثم الاحتواء، ثم الخطأ الإملائي */
function closeness(q: string, t: string): number {
  if (q === t) return 1;
  const short = Math.min(q.length, t.length);
  if (short >= 3 && (t.startsWith(q) || q.startsWith(t))) return 0.8;
  if (q.length >= 4 && t.includes(q)) return 0.6;
  if (q.length >= 4 && t.length >= 4) {
    const d = editDistance(q, t, 2);
    if (d === 1) return 0.6;
    if (d === 2 && q.length >= 7) return 0.4;
  }
  return 0;
}

type Prepared = { title: string; keys: string[]; tTitle: string[]; tKeys: string[]; tWhere: string[] };
const PREP = new WeakMap<SearchEntry, Prepared>();
const words = (s: string) => normalizeAr(s).split(' ').filter(w => w && !STOP.has(w)).map(stemAr);
function prepared(e: SearchEntry): Prepared {
  let p = PREP.get(e);
  if (!p) {
    p = { title: normalizeAr(e.title), keys: e.keywords.map(normalizeAr),
          tTitle: words(e.title), tKeys: e.keywords.flatMap(words), tWhere: words(e.where) };
    PREP.set(e, p);
  }
  return p;
}

/** نقاط كلمةٍ من الاستعلام في وجهة: أفضل قربٍ لها أو لمرادفاتها × ثقل موضعها (العنوان 3، الكلمات 2، الموضع 1) */
function tokenScore(q: string, p: Prepared): number {
  const variants = SYN_OF.get(q) ?? new Set([q]);
  let best = 0;
  for (const v of [q, ...variants]) {
    const syn = v === q ? 1 : 0.9;                     // المرادف أخفّ قليلًا من اللفظ نفسه
    for (const [list, w] of [[p.tTitle, 3], [p.tKeys, 2], [p.tWhere, 1]] as const) {
      for (const t of list) best = Math.max(best, closeness(v, t) * w * syn);
    }
  }
  return best;
}

/**
 * البحث: الأقرب أوّلًا بالنقاط — لا يشترط كل الكلمات (نصفها يكفي)، والعبارة كاملةً في العنوان أو الكلمات تُرجّح،
 * وما طابق عنوانه من أوّله أوّلًا.
 */
export function searchIndex(query: string, entries: SearchEntry[], limit = 8): SearchEntry[] {
  const q = normalizeAr(query);
  if (!q) return [];
  const tokens = q.split(' ').filter(w => !STOP.has(w)).map(stemAr).filter(w => w.length >= 2);
  if (!tokens.length) return [];
  const need = Math.max(1, Math.ceil(tokens.length / 2));
  const scored = entries.map(e => {
    const p = prepared(e);
    const per = tokens.map(t => tokenScore(t, p));
    const matched = per.filter(s => s >= 0.8).length;   // كلمةٌ «طابقت» = قربٌ معتبر لا لمسةٌ عابرة
    if (matched < need) return null;
    let score = per.reduce((a, b) => a + b, 0);
    if (p.title.startsWith(q)) score += 6;
    else if (p.title.includes(q)) score += 4;
    else if (p.keys.some(k => k === q)) score += 4;
    else if (p.keys.some(k => k.includes(q))) score += 2;
    score += matched === tokens.length ? 1 : 0;          // كل الكلمات طابقت
    return { e, score };
  }).filter((x): x is { e: SearchEntry; score: number } => x !== null);
  return scored.sort((a, b) => b.score - a.score).slice(0, limit).map(x => x.e);
}
